<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><i>This book is dedicated, as in all things in my life, to my children, Lynne, Leigh, Nedal and Suna, who have always given me the sense of purpose I need to reach for the heights.</i></p>
<p class="ded3"><i>Thanks to family and friends who gave me the love and support I needed to make it to the last page.</i></p>
<p class="ded3"><i>And a special nod to everyone who has ever stepped foot on a stage; without them the world would be a much less colorful place.</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedication.vue?a3127e9a